import React from 'react';

const HeaderTabButton = ({ label, count, selected, onClick, $isMobile }) => {
  return (
    <button
      type='button'
      onClick={onClick}
      className={`flex min-w-0 flex-col p-2 justify-center items-center gap-1 rounded-[15px] tabletH:rounded-[10px] flex-1 w-full h-[70px] tabletH:h-[90px]
      cursor-pointer transition-all duration-150
      ${selected ? 'bg-grayscale-gray00 shadow-3' : 'bg-transparent'}`}
    >
      <div
        className={`typo-title3 tabletH:typo-title1 ${
          selected ? 'text-text-primary' : 'text-text-secondary'
        }`}
      >
        {count}
      </div>

      <div
        className={`w-full truncate text-center typo-b11 tabletH:typo-b13 ${
          selected ? 'text-text-primary' : 'text-text-secondary'
        }`}
      >
        {label}
      </div>
    </button>
  );
};

export default HeaderTabButton;
